"use strict";

import React, { useMemo } from "react";
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Typography,
} from "@mui/material";
import { languages } from "../Data/languages";

const UserLanguageSelector = ({ selectedLanguages, onChange }) => {
    const sortedLanguages = useMemo(
        () => [...languages].sort((a, b) => a.name.localeCompare(b.name)),
        []
    );

    // HACK: Strip leading/trailing asterisks from labels until the language list stops mixing metadata.
    const getLanguageLabel = (name) => name.replace(/^[*\\s]+|[*\\s]+$/g, "");

    const handleToggle = (code) => {
        if (!onChange) {
            return;
        }

        if (selectedLanguages.includes(code)) {
            onChange(selectedLanguages.filter((language) => language !== code));
            return;
        }

        onChange([...selectedLanguages, code]);
    };

    return (
        <Box sx={{ fontFamily: "var(--font-body)" }}>
            <Typography variant="h6" gutterBottom>
                Fluent languages{" "}
                <Typography component="span" color="warning.main">
                    TODO ⚠️
                </Typography>
            </Typography>
            <Box
                sx={{
                    border: "1px solid #ccc",
                    borderRadius: 1,
                    paddingX: 2,
                    paddingY: 1,
                    backgroundColor: "#f9f9f9",
                    maxHeight: 220,
                    overflowY: "auto",
                }}
            >
                <FormGroup>
                    {sortedLanguages.map((language) => (
                        <FormControlLabel
                            key={language.code}
                            control={
                                <Checkbox
                                    checked={selectedLanguages.includes(language.code)}
                                    onChange={() => handleToggle(language.code)}
                                />
                            }
                            label={getLanguageLabel(language.name)}
                        />
                    ))}
                </FormGroup>
            </Box>
        </Box>
    );
};

export default UserLanguageSelector;
